import React from "react";
import { useSelector } from "react-redux";

import { ContentHolder } from "commons";

import { Settings } from "./Settings";

export function SettingsContainer() {
    const isAdviser = useSelector(state => Boolean(state.user.adviserId));
    return (
        <ContentHolder>
            <Settings isAdviser={isAdviser} />
        </ContentHolder>
    );
}
